// _basic/my-model
import {
  getData,
  postData,
  postFormData,
  createFormData,
} from 'src/services/RestApi';

export const getItems = async (
  payload,
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/demo/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) {
    return onError(error);
  }
  return onSuccess(result);
};

export const getItemById = async (payload) => {
  const endPoint = 'api/demo/detail';
  const { result, error } = await getData(endPoint, { myId: payload.id });
  return { result, error };
};

function requestParams(values, isUpdate = false) {
  const formData = createFormData(values);
  const queryData = {};
  if (isUpdate) {
    queryData.demoId = values.id;
  }
  if (values.plateField?.value) {
    queryData.carId = values.plateField.value;
  }
  if (values.created) {
    queryData.createdAt = Math.floor(new Date(values.created).getTime() / 1000);
  }
  if (values.odo) {
    queryData.lastKm = values.odo;
  }
  return { formData, queryData };
}

export const apiCreate = async (values) => {
  const { formData, queryData } = requestParams(values);
  return await postFormData(
    'api/demo/create',
    formData,
    queryData,
  );
};

export const apiUpdate = async (values) => {
  const queryParams = { demoId: values.id };
  return await postData('api/demo/update', queryParams);
};

export const apiRemove = async (values) => {
  // Implies taking something away, but it might still exist somewhere else. 
  // Move/Take away
};

export const apiDetele = async (values) => {
  // Implies permanent erasure.
  // Destroy/Erase
};
